import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {};
};

const LabelSetTags = {
  namespaced: true,
  state: defaultState,
  getters: {},
  mutations,
  actions,
};

export { LabelSetTags, defaultState };
